import { apiGet, apiPost, apiPatch, apiDelete } from "../shared/apiClient";
import { patchQueryPart } from "../shared/queryPartsModel";
import { runBusinessSend } from "../shared/businessSendAttempt";

export function addSupplierQuote(partId, { supplierId, price, warrantyDays = 0, deliveryCharge = 0, userId, remarks }) {
  return apiPost("/query_workflow/update_part_price", {
    query_part_id: partId,
    supplier_id: supplierId,
    price_received: price,
    warranty_days: warrantyDays,
    delivery_charge: deliveryCharge,
    ...(remarks ? { remarks } : {}),
  }).then(res => res.data);
}

export function editSupplierQuote(quoteId, { supplierId, price, deliveryCharge = 0, warrantyDays = 0, userId, remarks }) {
  return apiPatch(`/supplier-quotes/${quoteId}`, {
    supplier_id: supplierId,
    quoted_price: price,
    delivery_cost: deliveryCharge,
    warranty_days: warrantyDays,
    ...(remarks ? { remarks } : {}),
  }).then(res => res.data);
}

export function disableSupplierQuote(quoteId, userId) {
  return apiPatch(`/supplier-quotes/${quoteId}`, { quote_status: "disabled" }).then(res => res.data);
}

// Same PATCH used both for the "select which quote" action and for
// persisting a manually-edited selling price on the already-selected quote
// (PriceUpdateDrawer's handleSelectQuote/patchSellingPrice) — one primitive
// covers both call sites.
export function setPartQuote(partId, { selectedQuoteId, sellingPrice, userId }) {
  return patchQueryPart(partId, { selected_quote_id: selectedQuoteId, selling_price: sellingPrice });
}

export function fetchApprovalHistory(queryPk) {
  return apiGet(`/queries/${queryPk}/approvals`)
    .then(res => (res.data?.success ? (res.data.data ?? []) : null));
}

export function withdrawApproval(approvalId, userId) {
  return apiDelete(`/queries/approvals/${approvalId}`).then(res => res.data);
}

export function approveQuote(approvalId, { userId, modifiedPayload }) {
  return apiPost(`/queries/approvals/${approvalId}/approve`, { modified_payload: modifiedPayload }).then(res => res.data);
}

export function rejectQuote(approvalId, { userId, reason }) {
  return apiPost(`/queries/approvals/${approvalId}/reject`, { reason }).then(res => res.data);
}

export function shareQuote(queryPk, payload, { directWati = false, actor } = {}) {
  if (directWati) return runBusinessSend(actor, queryPk, "share-quote", payload);
  return apiPost(`/queries/${queryPk}/share-quote`, payload).then(res => res.data);
}

export function fetchQuoteSharePreflight(queryPk) {
  return apiGet(`/queries/${queryPk}/quote-share-preflight`).then(res => res.data);
}

export function fetchQuoteRecipientStatus(queryPk) {
  return apiGet(`/queries/${queryPk}/quote-recipient-status`).then(res => res.data);
}
